import { render, staticRenderFns } from "./Bear.vue?vue&type=template&id=056e3c54&scoped=true&"
import script from "./Bear.vue?vue&type=script&lang=js&"
export * from "./Bear.vue?vue&type=script&lang=js&"
import style0 from "./Bear.vue?vue&type=style&index=0&id=056e3c54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e3c54",
  null
  
)

export default component.exports